<template>

<main v-cloak>
  <!-- <span v-html="dashboardMessage"></span> -->
  <forms-list :forms="forms" class="forms-list" />
  <div class="right">
    <form-view v-if="!create" @updated="updated" />
    <forms-create v-if="create" @created="created" class="forms-create"/>
  </div>

</main>

</template>

<script>
/* eslint-disable import/no-cycle */
// import AuthService from '@/services/Auth';
import FormsService from '@/services/Forms';
import FormsList from './Forms/List';
import FormView from './Forms/View';
import FormsCreate from './Forms/Create';

export default {
  name: 'Dashboard',
  components: {
    FormsList,
    FormView,
    FormsCreate,
  },
  data() {
    return {
      dashboardMessage: null,
      forms: null,
      selectedForm: '',
      create: false,
      awayEntries: 0,
      title: document.title,
    };
  },
  methods: {
    async created(newForm) {
      this.forms.unshift(newForm.form);
      this.$router.push(newForm.created);
    },
    async updated() {
      this.forms = (await FormsService.index()).data;
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === 'Create') this.create = true;
      if (from.name === 'Create') this.create = false;
    },
  },
  async mounted() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) document.title = this.title;
    });
    if (this.$route.name === 'Create') {
      this.create = true;
    }
    this.forms = (await FormsService.index()).data;
    this.selectedForm = this.$route.params.id;
  },
  sockets: {
    connect() {
      this.$socket.emit('authenticate', { token: this.$store.token });
    },
    status(data) {
      console.log('data', data); // eslint-disable-line no-console
    },
    newEntry(data) {
      if (document.hidden) {
        this.awayEntries += 1;
        document.title = `(${this.awayEntries}) - ${this.title}`;
      }
      const listEl = document.querySelectorAll(`[data-form='${data.formID}'] .form-entries`)[0];
      listEl.style.color = 'var(--green)';
      window.setTimeout(() => { listEl.style.color = ''; }, 1000);
      this.forms.find((x) => x.id === data.formID).newEntries = (this.forms.find((x) => x.id === data.formID).newEntries || 0) + 1;
      this.forms.find((x) => x.id === data.formID).entriesCount += 1;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

main {
  width: 100%;
  display: flex;
}

.forms-list {
  width: 400px;
  min-width: 400px;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: scroll;

  color: var(--black);
}

.forms-list div:hover { overflow-y: scroll; }

.right {
  width: 100%;
  max-height: 100vh;
  /* overflow-y: hidden; */
  overflow-y: scroll;
}

</style>
